import { FollowUpConfigurationFragment } from "../../follow-up-configuration/graphql/fragments.generated"

export type FollowUpConfiguration = FollowUpConfigurationFragment

export type FollowUpConfigurationProduct =
  FollowUpConfigurationFragment["sourceProduct"]

export const FollowUpConfigurationTypename = "FollowUpConfiguration" as const

export const DimConfigurationTypename = "DimConfiguration" as const
